export async function getVimeoData({
  vimeoId,
  downloadProgress,
}: {
  vimeoId: string
  downloadProgress: Ref<number>
}) {
  const { $config } = useNuxtApp()

  const path = $config.public.apiRestEndpoint
  const response = await fetch(`${path}/vimeo/video/${vimeoId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  const clonedResponse = response.clone()

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const contentLength = clonedResponse.headers.get('content-length')
  const total = parseInt(contentLength, 10)

  // if (!contentLength || isNaN(total)) {
  //   throw new Error('Invalid or missing content-length header')
  // }

  let loaded = 0
  const reader = clonedResponse.body.getReader()
  while (true) {
    const { done, value } = await reader.read()
    if (done) {
      break
    }
    loaded += value.length
    downloadProgress.value = Math.floor((loaded / total) * 100)
  }
  return response?.json()
}
